export class StakeholderAddress {
  StakeEmail: string;
  StakeId: number;
}
